import { Alert } from "@/common/styles/style";
import { style } from "./style";

interface ErrorMessageProps {
  error: string | null;
}

export default function ErrorMessage({ error }: ErrorMessageProps) {
  return (
    <>
      {error && (
        <Alert severity="error" sx={style}>
          {error}
        </Alert>
      )}
    </>
  );
}
